import React, { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { getKPIs, getLoading } from '../redux/selectors';
import { get_stats } from '../redux/reducer';
import commaNumber from 'comma-number';
import { getAllProducts } from '@app/pages/products/redux/selectors';
import { get_all_products } from '@app/pages/products/redux/reducer';
import { getPageStats } from '@app/pages/meals/redux/selector';
import { get_meals } from '@app/pages/meals/redux/reducer';
const PlatformOverview = () => {
  const stat = useSelector(getKPIs);
  const loading = useSelector(getLoading);
  const allProducts = useSelector(getAllProducts);
  const pageStats = useSelector(getPageStats);
  const dispatch = useDispatch();
  const currentDate = new Date();

  useEffect(() => {
    dispatch(get_stats());
    dispatch(get_all_products());
    dispatch(get_meals({ page: 1, limit: 10 }));
  }, [dispatch]);

  const stats = [
    {
      title: 'All users',
      value: loading ? 0 : commaNumber(stat?.all_users || 0)
    },
    {
      title: 'All Products',
      value: loading ? 0 : commaNumber(allProducts?.length || 0)
    },
    {
      title: 'All Meals',
      value: loading ? 0 : commaNumber(pageStats?.docs || 0)
    },
    {
      title: 'New users',
      value: loading ? 0 : commaNumber(stat?.new_users || 0)
    }
  ];
  return (
    <div className="bg-[#FFFFFF] border border-[#E5E7EB] p-6 rounded-[20px] font-outfit shadow-[0px_1px_2px_0px_#0000000A,0px_1px_3px_0px_#0000000F]">
      <div>
        <p className="text-[#6B7280] text-[11px] font-semibold uppercase">
          Platform Overview
        </p>
        <p className="text-[11px] text-[#9CA3AF] font-normal">
          As of {moment(currentDate).format('DD MMMM YYYY')}{' '}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3.5 lg:grid-cols-4 mt-[18px]">
        {stats.map((stat, idx) => (
          <div
            className={`p-4 rounded-xl ${
              idx === 0
                ? 'bg-[#003232] border-[#00000000] border'
                : 'bg-[#F9FAFB] border-[#F3F4F6]'
            }`}
          >
            <p
              className={`font-medium uppercase text-[10px] ${
                idx === 0 ? 'text-[#FFFFFF8C]' : 'text-[#9CA3AF]'
              }`}
            >
              {stat.title}
            </p>
            <p
              className={`font-bold text-[26px] ${
                idx === 0 ? 'text-[#FFFFFF]' : 'text-[#111827]'
              }`}
            >
              {stat.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlatformOverview;
